import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import LoginHeader from './login.header';
import Arrow from '../../../components/common/arrow';
import { PALETTE, EBANKINGWEBLUX, EBANKINGWEBUK, EBANKINGWEB, KEY_CODE } from '../../../constants';
import envConfig from '../../../../db-env-build';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import Text, {H1} from '@dbk/ui-text';

class LoginContactUs extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { languages: { destLanguageCode }, auth: { setInvalidLogin} } = this.props;
        setInvalidLogin(false);
        if(document.querySelector('.contactUsFocus')){
            document.querySelector('.contactUsFocus').focus();
        }
    }

    onBackClick = (e) => {
        if(isEnterorSpaceKeyPressed(e)){   
            this.props.changePage('/login');
        }
    }

    render = () => {

        const { i18n: { messages }, ui: { history: { goBack } } } = this.props;

        return (
            <View className="login">
                <View className="login-container margin-bottom-30">
                    <LoginHeader />
                </View >
                <View className="faq-container">
                    <div className='display-flex-row'>
                        <div className='small-3 display-flex-row faq-title-container'>
                            <div tabIndex={0} className="cursor-pointer" onKeyDown={(e) => this.onBackClick(e)} onClick={() => this.onBackClick()} aria-label={messages['app.documentUpload.button.back']} role="button">
                                <Arrow
                                    direction="left"
                                    width={10}
                                    height={16}
                                    color={PALETTE.secondaryActive}
                                    thickness={2}
                                    id="arrow_backLink_test"
                                /></div>
                            <H1 tabIndex={0} className="padding-left-20 contactUsFocus" testID="text_loginTitle_userLogin_test" >{messages['app.login.contact.us']}</H1>
                        </div>
                    </div>
                    <div className='display-flex-row'>
                        <div className='small-6 bg-dawn-blue padding-25 margin-left-20'>
                            <Text size="large" tabIndex={0}>{messages["app.login.contact.us.content"]}</Text><br/>
                        </div>
                    </div>
                </View >
            </View>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        ui: {
            history: {
                goBack: { $call: 'goBack' },
            }
        },
        auth: {
            setInvalidLogin: { $set: 'invalidLogin'}
        }
    },
})(LoginContactUs);



